import { useDeleteCndnTypes } from "http-hooks/cndntypes/useCndnTypes";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteCndnTypes({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteCndnTypes();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Credit/Debit Note Type"
      description="Are you sure you want to delete this Credit/Debit Note Type? This type will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
